<!-- 公告管理 -->
<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="pt-2">
			<el-button type="primary" size="mini" @click="openModel(false)" icon="el-icon-search">查询</el-button>
			<el-button type="success" size="mini" @click="goda(1)" icon="el-icon-plus">添加</el-button>
		</div>

		<el-table class="mt-3" :max-height="maxHeight" :data="tableData" style="width: 100%" highlight-current-row @current-change="handleCurrentChange" size="mini">
			<el-table-column label="编号" width="80" align="center">
				<template slot-scope="scope">
					<div class="media" style="display: flex;justify-content: center;">{{ scope.row.id }}</div>
				</template>
			</el-table-column>
			<el-table-column label="部门名称" prop="name" width="180"></el-table-column>
			<el-table-column align="center" label="部门领导">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" plain>{{ scope.row.bmld.name }}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="企业微信ID" align="center">
				<template slot-scope="scope">
					<div class="media" style="display: flex;justify-content: center;">{{ scope.row.qywx }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="status" align="center" label="启用状态" v-if="tab != 'delete'">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain v-if="scope.row.state == 1">启用</el-button>
					<el-button type="danger" size="mini" plain v-else>禁用</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" align="center" width="240" label="创建时间"></el-table-column>
			<el-table-column align="center" fixed="right" width="220">
				<template slot="header" slot-scope="scope">
					操作
				</template>
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="goda(scope)">编辑</el-button>
					<el-button type="danger" size="mini" @click="deletes(scope)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'; // 引入 全局 公共数据
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
export default {
	inject: ['layout'],
	mixins: [common], // 引入mixins里的common.js
	data() {
		return {
			preUrl: 'bumen',
			maxHeight: 0,
			tableData: [],
			editIndex: -1,
			tab:'',
			form: {
				title: '',
				content: ''
			},
		};
	},
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
	},
	methods: {
		goda(e) {
			if (e == 1) {
				this.$router.push({
					name: 'zjb_bmjg'
				});
			} else {
				this.$router.push({
					name: 'zjb_bmjg',
					params: {
						data: e.row
					}
				});
			}
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			console.log(99, e.list);
			this.tableData = e.list;
		},
		deletes(e) {
			this.axios
				.delete('/admin/bumen/' + e.row.id + '/delete', {
					token: true
				})
				.then(res => {
					this.getList();
				});
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style>
.el-table thead {
	color: #333;
}
</style>
